import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Avatar,
  Box,
  ListItemButton,
  Stack,
  Typography,
  Chip,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import SectionGrid from "components/ui/atoms/SectionGrid";
import { InvestmentStatusTag } from "components/ui/atoms/Tag";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";

const DealSnapshotListItem = ({ snapshot, onClick }) => {
  return (
    <ListItemButton onClick={onClick}>
      <Box width="100%">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
        >
          <Box display="flex" alignItems="center">
            <Avatar
              src={`http://logo.clearbit.com/${snapshot.company.best_domain}`}
              sx={{ width: 24, height: 24, mr: 2 }}
            >
              <ApartmentSharpIcon />
            </Avatar>
            <Typography variant="subtitle2">
              {snapshot.company.best_name}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="caption" sx={{ mr: 4 }}>
              {snapshot.deal?.deal_owner_detail?.fullname}
              {snapshot.deal?.secondary_owner_detail?.fullname
                ? ", " + snapshot.deal?.secondary_owner_detail?.fullname
                : ""}
            </Typography>
            <InvestmentStatusTag status={snapshot.investment_status} />
            {snapshot.committee_print_section == "INVESTMENT_DECISION" && (
              <Tooltip
                title={"Invesment Decision: " + snapshot.comment_investment}
              >
                <Chip label="ID" size="small" color="warning" />
              </Tooltip>
            )}
          </Box>
        </Stack>
        <Grid container>
          <SectionGrid title="Comment" size={12} dividerSx={{ pb: 0 }}>
            <TypographyWithMiss
              variant="caption"
              whiteSpace="pre-line"
              isMissing={
                snapshot.comment.trim() === "" || snapshot.comment === null
              }
            >
              {snapshot.comment}
            </TypographyWithMiss>
          </SectionGrid>
          {snapshot?.reason_to_close && (
            <SectionGrid
              title="Lost/Drop reason"
              item
              size={12}
              dividerSx={{ pb: 0 }}
            >
              <TypographyWithMiss
                variant="caption"
                whiteSpace="pre-line"
                isMissing={
                  snapshot.reason_to_close?.trim() === "" ||
                  snapshot.reason_to_close === null
                }
                sx={{ mb: 1 }}
              >
                {snapshot.reason_to_close}
              </TypographyWithMiss>
            </SectionGrid>
          )}
          <Grid size={12}>
            <Typography variant="caption" sx={{ color: "secondary.main" }}>
              Minutes of{" "}
              {dayjs(snapshot.committee_minute.created_at).format("DD/MM/YYYY")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </ListItemButton>
  );
};

export default DealSnapshotListItem;
